<template>
  <div class="source-content">
    <div class="filter-bar flex items-center">
      <div class="tb-form-group flex-grow margin-bottom-none">
        <i class="icon icon-magnifier"></i>

        <input
          type="search"
          class="tb-input tb-input--search"
          placeholder="Search collections"
          v-model="keywordSearch"
          spellcheck="true"
          data-entity="producer-assets-searchShoppableCollections"
          data-test="producer-assets-collectionsSearch"
        />

        <button
          v-show="keywordSearch"
          class="search-clear-button"
          data-entity="producer-assets-clearShoppableCollectionSearch"
          data-test="producer-assets-clearCollectionsSearch"
          @click="resetCollectionSearch"
        >
          <span class="fa fa-times"></span>
        </button>
      </div>
    </div>

    <!-- No boards after searching -->
    <div v-if="!isLoadingCollections && !collections.length && keywordSearch" class="text-center margin-bottom-md">
      <h3 class="margin-bottom-md">
        No Collections found
      </h3>

      <button
        class="tb-btn tb-btn-contained medium-em"
        data-entity="producer-assets-resetShoppableCollectionSearch"
        data-test="producer-assets-resetCollectionsSearch"
        @click="resetCollectionSearch"
      >
        Reset Search
      </button>
    </div>

    <!-- Collections -->
    <div
      ref="sourceList"
      class="source-list"
      data-test="producer-assets-curatedContent-list"
    >
      <button
        class="source-item cursor-pointer"
        data-test="producer-collection-allProducts"
        @click="setSelectedCollection(-1)"
      >
        <div class="source-item-wrapper">
          <div class="source-title">
            <span class="fas fa-bookmark margin-right-xs"></span>
            All Saved Products
          </div>
        </div>
      </button>
      <button
        v-for="collection in collections"
        :key="collection.id"
        class="source-item cursor-pointer"
        :data-test="`producer-collection-:${collection.id}`"
        @click="setSelectedCollection(collection.id)"
      >
        <div class="source-item-wrapper">
          <span class="source-title">{{ collection.name }}</span>
        </div>
      </button>

      <div ref="loadTrigger" class="load-trigger">
        <div v-if="isLoadingCollections" class="loading loading--inline" data-test="producer-assets-curatedContent-loading">
          <i class="icon icon-spinner"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { debounce } from 'lodash-es';

import tabMixins from '@/js/mixins/tab-mixins';

export default {
  name: 'CollectionList',
  mixins: [tabMixins],
  data() {
    return {
      intersectionObserver: null,
    };
  },
  computed: {
    ...mapState('shoppable', [
      'collections',
      'collectionTotal',
      'isLoadingCollections',
      'collectionSearch',
    ]),
    ...mapGetters('shoppable', [
      'hasMoreCollections',
    ]),

    keywordSearch: {
      get() {
        return this.collectionSearch;
      },
      set: debounce(function(value) {
        this.searchCollections(value);
      }, 500),
    },
  },
  watch: {
    isLoadingCollections(newVal) {
      if (!newVal && this.$refs.sourceList) {
        this.$nextTick(() => {
          if (this.$refs.sourceList.scrollHeight <= this.$refs.sourceList.offsetHeight) {
            // re-trigger observer
            this.intersectionObserver.unobserve(this.$refs.loadTrigger);
            this.intersectionObserver.observe(this.$refs.loadTrigger);
          }
        });
      }
    },
  },
  
  mounted() {
    this.intersectionObserver = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.loadMore();      
      }
    }, {
      root: this.$refs.sourceList,
      threshold: 0,
    });

    this.intersectionObserver.observe(this.$refs.loadTrigger);
  },

  beforeDestroy() {
    this.intersectionObserver.disconnect();
  },
  methods: {
    ...mapActions('shoppable', [
      'incrementCollectionPage',
      'searchCollections',
      'resetCollectionSearch',
      'setSelectedCollection',
    ]),

    async loadMore() {
      if (!this.isLoadingCollections && this.hasMoreCollections) {
        await this.incrementCollectionPage();
      }
    },
  },
};
</script>
